import { useTranslation } from 'react-i18next'
import { Item, ItemLabel, ItemValue } from '../_styles'
import { useProduct } from '../../../_methods'

const WineTypeEU = () => {
  const { t } = useTranslation()

  const product = useProduct()
  const value = product?.wine?.wineTypeEU?.localizedName

  if (!value) return null

  return (
    <Item>
      <ItemLabel>{t('wine.view.wineTypeEU')}</ItemLabel>
      <ItemValue>{value}</ItemValue>
    </Item>
  )
}

export default WineTypeEU
